import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as KeyboardShortcutsIcon } from '~app/resources/images/icons/keyboard-shortcuts.svg';
import { actions as CanvasActions } from '~app/features/canvas';
import { useT } from '~app/core/BundleProvider';
import useGlobalHotkey from '~app/core/useGlobalHotkey';
import withEnterToClick from '~app/core/withEnterToClick';

const ClickOrEnterDiv = withEnterToClick('div');
// Keyboard shortcuts icon in the workspace
function KeyboardShortcutsButton() {
  const t = useT();
  const dispatch = useDispatch();
  const showKeyboardShortcuts = useSelector(
    state => state.canvas.showKeyboardShortcuts,
  );
  const openKeyboardShortcuts = useCallback(() => {
    if (!showKeyboardShortcuts) {
      dispatch(CanvasActions.showKeyboardShortcuts());
    }
  }, [dispatch, showKeyboardShortcuts]);
  useGlobalHotkey({
    hotkey: '',
    callback: openKeyboardShortcuts,
    event: 'keyup',
    priority: 10,
    stop: true,
  });
  return (
    <ClickOrEnterDiv
      tabIndex={0}
      role="button"
      aria-label={t('open-keyboard-shortcuts')}
      className="KeyboardShortcuts__icon"
      onClick={openKeyboardShortcuts}
    >
      <KeyboardShortcutsIcon />
    </ClickOrEnterDiv>
  );
}

export default KeyboardShortcutsButton;
